import React from 'react';
import { Switch, Route, Redirect, useParams } from 'react-router-dom';
import { routes } from 'config';
import { useBillingStatus } from 'hooks/use-billing-status.hook';
import { BillingBase } from '../billing-base';
import { Statement } from '../secondary/statement';
import { Statements } from '../secondary/statements';
import { PayBalance } from '../secondary/pay-balance';

const BillingClosed = () => {
  const { planId } = useParams<{ planId?: string }>();
  const { data, error, loading } = useBillingStatus({
    planId: Number(planId),
  });

  const { issuedStatements, mostRecentStatement, balances, paymentLink } = data;

  return (
    <BillingBase
      error={error}
      issuedStatements={issuedStatements}
      loading={loading}
      mostRecentStatement={mostRecentStatement}
      balances={balances}
      paymentLink={paymentLink}
    />
  );
};

export const Closed = () => {
  const routeTemplates = routes();
  console.log('Billing Closed Routes Loaded');
  console.log(routeTemplates.payBalance);

  return (
    <Switch>
      <Route path={routeTemplates.statement} component={Statement} />
      <Route path={routeTemplates.statements} component={Statements} />
      <Route path={routeTemplates.payBalance} component={PayBalance} />
      <Route path={routeTemplates.billing} component={BillingClosed} />
      <Redirect to={routeTemplates.billing} />
    </Switch>
  );
};
